// @flow
import React, { Component } from 'react';
// import styled from "react-emotion";
import iconCart from '../assets/images/icon_cart.svg';
import iconCartLoading from '../assets/images/icon_cart_loading.svg';
import Button from './Button';
import {
  // getVariations,
  addToCart,
  createVariation,
  maybeDeleteOldVariations,
} from '../services/api.service';
import { colors } from '../assets/scripts/constants';
// import { checkIfVariationExists } from '../assets/scripts/helpers';

/**
 * Component: AddToCart
 *
 * Adds current config to WooCommerce cart
 */
class AddToCart extends Component<
  {
    configData: { [string]: Object },
    goToFinalPage: Function,
  },
  {
    loading: boolean,
    error: boolean,
    success: boolean,
  }
> {
  state = {
    loading: false,
    error: false,
    success: false,
  };

  componentDidUpdate() {
    if (this.state.success) {
      this.props.goToFinalPage('success');
    }
  }

  /**
   * Update the Frontend cart if available, and push data to dataLayer.
   */
  async updateCart() {
    const { configData } = this.props;

    // Update Frontend cart
    if (typeof window.jQuery !== 'undefined') {
      const $ = window.jQuery;
      const $eclisseCart = $('.js-eclisse-cart');
      const currentCartQuantity = Number.parseInt(
        $eclisseCart.attr('data-quantity'),
        10
      );

      if (currentCartQuantity >= 0) {
        const configQuantity =
          +(configData.quantity && configData.quantity.value) || 1;
        $eclisseCart.attr(
          'data-quantity',
          currentCartQuantity + configQuantity
        );
      }
    }

    // Push cart data to dataLayer.
    if (typeof window.cartAnalytics === 'object') {
      window.cartAnalytics.update();
    }
  }

  /**
   * Handles Add to Cart
   *
   * @returns {void}
   */
  async handleAddToCart() {
    try {
      // Prepare analytics
      if (typeof window.cartAnalytics === 'object') {
        window.cartAnalytics.start();
      }
      // Begin operation and show this in the UI.
      this.setState({ loading: true });
      const { configData } = this.props;
      /*
       * Lets check if no problems arise from creating a new variation
       * every time
       *

      // Get existing variations from WP.
      const variations = await getVariations();
      // If variation exists already, use its ID.
      let variationId = checkIfVariationExists({ configData, variations });
      // If not, create a new variation with the config and grab the ID.
      if (!variationId) {
        variationId = await createVariation(configData);
      }

      *
      */
      const variationId = await createVariation(configData);
      // Add the product to the WC cart with given quantity.
      await addToCart(configData, variationId);
      // Maybe delete old variations.
      maybeDeleteOldVariations();
      this.updateCart();
      this.setState({ success: true, error: false });
    } catch (e) {
      console.error(e);
      this.setState({ error: true });
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { configData } = this.props;
    let buttonText = '';
    switch (true) {
      case this.state.loading:
        buttonText = 'Lisätään...';
        break;
      case this.state.error:
        buttonText = 'Yritä uudelleen!';
        break;
      case this.state.success:
        buttonText = 'Tuote lisätty!';
        break;
      default:
        buttonText = 'Lisää ostoskoriin';
        break;
    }

    return (
      <React.Fragment>
        {
          <Button
            bgColor={this.state.error && colors.red}
            disabled={
              this.state.success ||
              this.state.loading ||
              Object.keys(configData).length < 12
            }
            xlarge
            onClick={() => {
              this.handleAddToCart();
            }}
          >
            <div>
              <img
                src={this.state.loading ? iconCartLoading : iconCart}
                alt=""
              />
              <span>{buttonText}</span>
            </div>
          </Button>
        }
      </React.Fragment>
    );
  }
}

export default AddToCart;



// WEBPACK FOOTER //
// ./src/components/AddToCart.js